import ApiService from '@/services/api.service';

export const profession = {
  type: '',
  id: '',
  attributes: {
    name: '',
    description: '',
    deletedAt: null,
    createdAt: null,
    updatedAt: null,
  },
  relationships: {
    offices: {
      links: {
        related: '',
        self: '',
      },
    },
  },
  links: {
    self: '',
  },
};

const state = {
  isLoading: false,
  error: null,
  profession: profession,
  professions: {
    data: [profession],
    included: [],
    meta: {
      page: {
        currentPage: 0,
        from: 0,
        lastPage: 0,
        perPage: 0,
        to: 0,
        total: 0,
      },
    },
  },
};

const getters = {
  getLoading: (state) => {
    return state.isLoading;
  },
  getProfession: (state) => {
    return state.profession;
  },
  getProfessions: (state) => {
    return state.professions;
  },
  getError: (state) => {
    return state.error;
  },
};

const mutations = {
  setLoader: (state, status) => (state.isLoading = status),
  setProfessions: (state, data) => (state.professions = data),
  setProfession: (state, data) => (state.profession = data),
  setError: (state, data) => (state.error = data),
};

const actions = {
  async fetchProfessions({ commit }, { params = {}, fields } = {}) {
    commit('setLoader', true);
    try {
      if (fields) {
        Object.entries(fields).forEach(([prop, value]) => {
          Object.assign(params, {
            [`fields[${prop}]`]: value,
          });
        });
      }

      let response = await ApiService.get(`/api/v1/professions`, { params });
      commit('setProfessions', response.data);
      return response;
    } catch (error) {
      commit('setError', error.response.data.errors);
    } finally {
      commit('setLoader', false);
    }
  },
  async createProfession({ commit, dispatch }, { payload }) {
    commit('setLoader', true);
    try {
      let response = await ApiService.post(`/api/v1/professions`, payload);
      commit('setProfession', response.data);
      dispatch(
        'alert/createAlert',
        { data: 'Profesi berhasil ditambahkan' },
        { root: true }
      );
      return response;
    } catch (error) {
      if (error?.response?.status === 422) {
        commit('setError', error.response.data.errors[0].detail);
      } else {
        commit('setError', 'Gagal');
      }
    } finally {
      commit('setLoader', false);
    }
  },
  async updateProfession({ commit, dispatch }, { payload }) {
    commit('setLoader', true);
    try {
      let response = await ApiService.patch(
        `/api/v1/professions/${payload.data.id}`,
        payload
      );
      commit('setProfession', response.data);
      dispatch(
        'alert/createAlert',
        {
          data: `Profesi berhasil di${
            payload.data.attributes.deletedAt ? 'hapus' : 'ubah'
          }`,
        },
        { root: true }
      );
      return response;
    } catch (error) {
      if (error?.response?.status === 422) {
        commit('setError', error.response.data.errors[0].detail);
      } else {
        commit('setError', 'Gagal');
      }
    } finally {
      commit('setLoader', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
